<template>
    <div class="mall-side">
        <div class="side-menu">
            <div class="menu-items">
                <div class="side-item" @click="$router.push({name:'MallShopCart'})">
                    <div v-if="cart_count>0" class="tag">{{cart_count}}</div>
                    <img src="@/assets/images/icon-mall-side-cart.png" alt="" class="icon">
                    购物车
                </div>
                <div class="side-item" @click="onCollectClick">
                    <img src="@/assets/images/icon-mall-side-collect.png" alt="" class="icon">
                    收藏
                </div>
                <div class="side-item" @click="showChat">
                    <img src="@/assets/images/icon-mall-side-custom.png" alt="" class="icon">
                    客服
                </div>
            </div>
            <div class="to-top" @click="scrollToTop">
                <Icon type="ios-arrow-up" color="#ffffff" size="28" />
            </div>
        </div>
        <chat ref="chat"></chat>
    </div>
</template>
<script>
import { cartCount } from '@/api/index';
import { mapState } from 'vuex';
export default{
    data(){
        return{
            cart_count:0
        }
    },
    computed:{
        ...mapState({
            is_login: state => state.is_login
        })
    },
    watch:{
        '$route.name':{
            handler(){
                this.onGetCartNum();
            },
            deep: true,
            immediate: true
        }
    },
    mounted(){
        // this.onGetCartNum();
    },
    methods:{
        async onGetCartNum(){
            try{
                const {code,msg,data} = await cartCount();
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.cart_count = data.num || 0;
            }catch(e){
                console.log('err->getCartNum',e);
            }
        },
        onCollectClick(){
            console.log('route.name',this.$route.name);
            if(this.$route.name === 'MallCollection'){
                return;
            }
            this.$router.push({name:'MallCollection'});
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        showChat(){
            if(!this.is_login){
                this.$layer.msg('请先登录');
                this.$router.replace({name:'Login'});
                return;
            }
            // this.$emit('show-chat');
            this.$refs.chat.showChat();
        }
    }
}
</script>
<style lang="scss" scoped>
.mall-side{
    width:0;
    height:0;
    // width:100%;
    // height:100%;
    // float:right;
    .side-menu{
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        position:fixed;
        right:1%;
        top:50%;
        transform:translateY(-50%);
        width:50px;
        z-index:198;
        .menu-items{
            width:100%;
            overflow:hidden;
            border-radius:10px;
            box-shadow:0px 0px 8px 0px #ebebeb;
            background:#ffffff;
            .side-item{
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                width:100%;
                cursor:pointer;
                color:#666666;
                font-size:12px;
                padding:10px 0;
                position:relative;
                .tag{
                    position:absolute;
                    top:5px;
                    right:5px;
                    background:#ff5967;
                    color:#ffffff;
                    font-size:12px;
                    // line-height:1.5;
                    padding:1px 6px;
                    border-radius:50%;
                    white-space:nowrap;
                    text-overflow:ellipsis;
                    overflow:hidden;
                    // min-width:20px;
                    // min-height:20px;
                    display:flex;
                    align-items:center;
                    justify-content:center;

                }
                .icon{
                    width:28px;
                    height:28px;
                }
                &:hover{
                    background:#ededed;
                }
            }
        }
        .to-top{
            width:50px;
            height:50px;
            border-radius:10px;
            background:#4d4d4d;
            display:flex;
            align-items:center;
            justify-content:center;
            margin-top:13px;
            cursor:pointer;
        }
    }
}
</style>